<template>
  <section class="section">
    <div class="columns">
      <div class="column is-2">
        <div v-if="itemData.image.formats.medium.url">
          <img class="imgb" :src="$mySite.resurces + itemData.image.formats.medium.url" alt="">
        </div>
      </div>
      <div class="column">
        <div class="content">
          <h2 class="title">
            <a @click="showDetails(itemData.id)">{{ itemData.title }}</a>
          </h2>
          <div class="subtitle">
            {{ itemData.date }}
          </div>
          <div>
            {{ itemData.content | limitText }}
            <br />
            <div class="buttons">
              <button @click="showDetails(itemData.id)" class="button is-info m-t-md">{{$locales[lang].more}}</button>
              <button @click="showDonate()" class="button is-success m-t-md">{{$locales[lang].donate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ProjectItem",
  props: {
    itemdata: Object,
    itemid: Number
  },
  data() {
    return {
      imgLoaded: false
    };
  },
  methods: {
    showDetails(id) {
      console.log("Show details");
      this.$router.push({ path: "/project-item/" + id });
    },
    showDonate() {
      this.$router.push({ path: "/donations"});
    }
  },
  computed: {
    ...mapState(["lang"]),
    itemID: {
      get: function() {
        return this.itemid;
      }
    },
    itemData: {
      get: function() {
        return this.itemdata; // JSON.parse(this.itemdata.jdata);
      }
    }
  },
  filters: {
    dateFormat(timestamp) {
      // Create a date object from the timestamp
      let date = new Date(timestamp);

      // Create a list of names for the months
      let months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];

      // return a formatted date
      return (
        months[date.getMonth()] +
        " " +
        date.getDate() +
        ", " +
        date.getFullYear()
      );
    },
    limitText(value) {
      return value.substring(0, 300)+"...";
    }
  }
};
</script>
<style scoped>
.subtitle {
  font-size: small;
}
</style>
